export default {"src":"/images/5.jpg","width":5184,"height":3456,"aspectRatio":1.5};